import axiosInstance from "../utils/axiosInstance";

export const getPublishedBlogs = async () => {
  const res = await axiosInstance.get("/api/blog/published");
  return res.data.data;
};

export const getBlogBySlug = async (slug) => {
  const res = await axiosInstance.get(`/api/blog/slug/${slug}`);
  return res.data.data;
};
